import { Drawer, Descriptions, message, Button, Skeleton, Divider, Modal, InputNumber, Col, Form, Row, Input } from "antd";
import { useImperativeHandle, forwardRef, useState } from "react";
import { useQuery, useMutation } from "react-query";
import { postMerchantInfo } from "api/MerchantApi"

import { numberFormat } from "components/Jarvis";

const SettlementInfoEdit = forwardRef((props, ref) => {
    const [form] = Form.useForm()
    const [open, setOpen] = useState(false)
    const [changedFormValue, setChangedFormValue] = useState([]);
    const { mutate: postMerchantInformation, isLoading: postMerchantInfoIsLoading, isUpdating } = useMutation((values) => postMerchantInfo(values), {
        onSuccess: (data) => {
            // TODO handle error response
            if (data.code != 200) {
                message.info("Application Apply failed. Please contact us")
            } else {
                message.info("This Application Applied, We will check it.")
                props?.onChange();
                setOpen(false)
            }
        }
    })

    useImperativeHandle(ref, () => ({
        show,
        close
    }), []);

    const close = () => {
        if (!postMerchantInfoIsLoading) {
            setOpen(false);
        }
    };
    if (postMerchantInfoIsLoading) { return <Skeleton active />; }

    const onOk = () => {
        form.validateFields().then((values) => {
            let data = { merchant: {code:props.data.code} }
            changedFormValue.forEach(element => {
                data.merchant[element] = form.getFieldValue(element)
            });
            postMerchantInformation(data);
        })
    }
    const show = () => {
        setOpen(true);
    }
    const handleValueChange = (changedValues) => {
        for (let [k, v] of Object.entries(changedValues)) {
            if (!changedFormValue.includes(k)) {
                setChangedFormValue([...changedFormValue, k])
            }
        }
    };

    return (
        <Modal
            class=""
            title=""
            open={open}
            onOk={onOk}
            onCancel={close}
            centered
        >
            <Form
                form={form}
                layout="vertical"
                onValuesChange={handleValueChange}
                initialValues={{
                    bank_account_name: props.data.bank_account_name,
                    bank_account_number: props.data.bank_account_number,
                    settlement_period: props.data.settlement_period,
                    settlement_currency: props.data.settlement_currency,
                    settlement_min_amount: numberFormat(props.data.settlement_min_amount),


                }}
            //==onFinish={(values) => finsihFunction(values)}
            >
                <Row gutter={[8, 8, 8]}>
                    <Col span>
                        <Form.Item
                            name="bank_account_name"
                            label={"Beneficiary Name"}
                            rules={[
                                {
                                    required: true,
                                    message: "Please input Beneficiary Name !",
                                    max: ""
                                }
                            ]}
                        >
                            <Input placeholder="Beneficiary Name" value={props} />
                        </Form.Item>
                    </Col>

                    <Col>
                        <Form.Item
                            name="bank_account_number"
                            label={"Beneficiary Account"}
                            rules={[
                                {
                                    required: true,
                                    message: "Please input Beneficiary Account!",
                                    max: ""
                                }
                            ]}
                        >
                            <Input placeholder="Settlement Min Amount" />
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={[8, 8, 8]}>
                    <Col>
                        <Form.Item
                            name="settlement_period"
                            label={"Settlement Period"}
                            rules={[
                                {
                                    required: true,
                                    message: "Please input SWIFTCode !",
                                    max: ""
                                }
                            ]}
                        >
                            <Input placeholder="SWIFTCode" />
                        </Form.Item>
                    </Col>

                    <Col>
                        <Form.Item
                            name="settlement_currency"
                            label={"Settlement Currency"}
                            rules={[
                                {
                                    required: true,
                                    message: "Please input Settlement Currency !",
                                    max: ""
                                }
                            ]}
                        >
                            <Input placeholder="Settlement Currency" />
                        </Form.Item>
                    </Col>

                    <Col>
                        <Form.Item
                            name="settlement_min_amount"
                            label={"Settlement Min Amount"}
                            rules={[
                                {
                                    required: true,
                                    message: "Please input Settlement Min Amount !",
                                    
                                    min:0
                                }
                            ]}
                        >
                            <InputNumber placeholder="Settlement Min Amount" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>)
})
export default SettlementInfoEdit;